import React, {FC} from 'react';
import {connect} from 'react-redux';

import {PanelTypesEnum} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../srcCommon/helpers/reselectHelpers';
import {ApplicationPanelLocationsEnum} from '../../store/panels/applications/applicationPanelState';
import {getFlatPanels} from '../../store/panels/panelsSelectors';
import {PanelState} from '../../store/panels/panelsState';
import {Popup} from './popup';

/*
 * Props.
 */

interface PopupsContainerStateProps {
  panels: ReadonlyArray<PanelState>;
}

/*
 * Component.
 */

const PopupsContainerComponent: FC<PopupsContainerStateProps> = ({panels}) => (
  <>
    {panels.map((panel) => {
      if (
        panel.type === PanelTypesEnum.APPLICATIONS &&
        panel.location !== ApplicationPanelLocationsEnum.POPOUT_WINDOW
      ) {
        return null;
      }

      // If this panel is not a popup, no need to render anything.
      if (!panel.popupAppPanelId && panel.type !== PanelTypesEnum.APPLICATIONS) {
        return null;
      }

      return <Popup key={panel.id} panel={panel} />;
    })}
  </>
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  panels: getFlatPanels,
}));

export const PopupsContainer = connect(mapStateToProps)(PopupsContainerComponent);
